var _desc, _style, _g, _tspan, _tspan2, _tspan3, _tspan4, _rect, _tspan5, _tspan6, _polygon, _rect2, _tspan7, _rect3, _tspan8, _tspan9, _rect4, _tspan0, _tspan1, _rect5, _tspan10, _tspan11, _polygon2, _rect6, _tspan12, _tspan13, _rect7, _tspan14, _tspan15, _rect8, _tspan16, _tspan17, _tspan18, _rect9, _tspan19, _tspan20, _tspan21, _rect0, _tspan22, _tspan23, _tspan24, _defs, _defs2, _linearGradient;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "my-svg",
    width: 456,
    height: 1174,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: "flowchart",
    style: {
      maxWidth: 456,
      backgroundColor: "transparent"
    },
    viewBox: "4 4 456 1174",
    role: "graphics-document document",
    "aria-roledescription": "flowchart-v2",
    "aria-describedby": "chart-desc-my-svg",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "chart-title-my-svg"
  }, "Respond to a blocking conflict") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "chart-title-my-svg"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "chart-desc-my-svg"
  }, "Correct and recalculate first. An authorized override requires a reason and records remaining blockers.")), _style || (_style = /*#__PURE__*/React.createElement("style", null, "#my-svg{font-family:Arial,sans-serif;font-size:16px;fill:#20303a;}@keyframes edge-animation-frame{from{stroke-dashoffset:0;}}@keyframes dash{to{stroke-dashoffset:0;}}#my-svg .edge-animation-slow{stroke-dasharray:9,5!important;stroke-dashoffset:900;animation:dash 50s linear infinite;stroke-linecap:round;}#my-svg .edge-animation-fast{stroke-dasharray:9,5!important;stroke-dashoffset:900;animation:dash 20s linear infinite;stroke-linecap:round;}#my-svg .error-icon{fill:#ffffff;}#my-svg .error-text{fill:#000000;stroke:#000000;}#my-svg .edge-thickness-normal{stroke-width:1px;}#my-svg .edge-thickness-thick{stroke-width:3.5px;}#my-svg .edge-pattern-solid{stroke-dasharray:0;}#my-svg .edge-thickness-invisible{stroke-width:0;fill:none;}#my-svg .edge-pattern-dashed{stroke-dasharray:3;}#my-svg .edge-pattern-dotted{stroke-dasharray:2;}#my-svg .marker{fill:#667684;stroke:#667684;}#my-svg .marker.cross{stroke:#667684;}#my-svg svg{font-family:Arial,sans-serif;font-size:16px;}#my-svg p{margin:0;}#my-svg .label{font-family:Arial,sans-serif;color:#20303a;}#my-svg .cluster-label text{fill:#000000;}#my-svg .cluster-label span{color:#000000;}#my-svg .cluster-label span p{background-color:transparent;}#my-svg .label text,#my-svg span{fill:#20303a;color:#20303a;}#my-svg .node rect,#my-svg .node circle,#my-svg .node ellipse,#my-svg .node polygon,#my-svg .node path{fill:#edf5f8;stroke:#2e718e;stroke-width:1px;}#my-svg .rough-node .label text,#my-svg .node .label text,#my-svg .image-shape .label,#my-svg .icon-shape .label{text-anchor:middle;}#my-svg .node .katex path{fill:#000;stroke:#000;stroke-width:1px;}#my-svg .rough-node .label,#my-svg .node .label,#my-svg .image-shape .label,#my-svg .icon-shape .label{text-align:center;}#my-svg .node.clickable{cursor:pointer;}#my-svg .root .anchor path{fill:#667684!important;stroke-width:0;stroke:#667684;}#my-svg .arrowheadPath{fill:#0b0b0b;}#my-svg .edgePaths .path{stroke:#667684;stroke-width:1px;}#my-svg .flowchart-link{stroke:#667684;fill:none;}#my-svg .edgeLabel{background-color:#f8fafb;text-align:center;}#my-svg .edgeLabel p{background-color:#f8fafb;}#my-svg .edgeLabel rect{opacity:0.5;background-color:#f8fafb;fill:#f8fafb;}#my-svg .labelBkg{background-color:rgba(248, 250, 251, 0.5);}#my-svg .cluster rect{fill:#ffffff;stroke:hsl(0, 0%, 90%);stroke-width:1px;}#my-svg .cluster text{fill:#000000;}#my-svg .cluster span{color:#000000;}#my-svg .node .collapsed-indicator{fill:hsl(0, 0%, 90%);stroke:none;opacity:0.6;}#my-svg .node .collapsed-separator{stroke:hsl(0, 0%, 90%);stroke-width:0.75px;}#my-svg div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:Arial,sans-serif;font-size:12px;background:#ffffff;border:1px solid hsl(0, 0%, 90%);border-radius:2px;pointer-events:none;z-index:100;}#my-svg .flowchartTitleText{text-anchor:middle;font-size:18px;fill:#20303a;}#my-svg rect.text{fill:none;stroke-width:0;}#my-svg .icon-shape,#my-svg .image-shape{background-color:#f8fafb;text-align:center;}#my-svg .icon-shape p,#my-svg .image-shape p{background-color:#f8fafb;padding:2px;}#my-svg .icon-shape .label rect,#my-svg .image-shape .label rect{opacity:0.5;background-color:#f8fafb;fill:#f8fafb;}#my-svg .label-icon{display:inline-block;height:1em;overflow:visible;vertical-align:-0.125em;}#my-svg .node .label-icon path{fill:currentColor;stroke:revert;stroke-width:revert;}#my-svg .node .neo-node{stroke:#2e718e;}#my-svg [data-look=\"neo\"].node rect,#my-svg [data-look=\"neo\"].cluster rect,#my-svg [data-look=\"neo\"].node polygon{stroke:url(#my-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#my-svg [data-look=\"neo\"].swimlane.cluster rect{filter:none;}#my-svg [data-look=\"neo\"].node path{stroke:url(#my-svg-gradient);stroke-width:1px;}#my-svg [data-look=\"neo\"].node .outer-path{filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#my-svg [data-look=\"neo\"].node .neo-line path{stroke:#2e718e;filter:none;}#my-svg [data-look=\"neo\"].node circle{stroke:url(#my-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#my-svg [data-look=\"neo\"].node circle .state-start{fill:#000000;}#my-svg [data-look=\"neo\"].icon-shape .icon{fill:url(#my-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#my-svg [data-look=\"neo\"].icon-shape .icon-neo path{stroke:url(#my-svg-gradient);filter:drop-shadow( 1px 2px 2px rgba(185,185,185,1));}#my-svg :root{--mermaid-font-family:Arial,sans-serif;}")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-pointEnd",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refX: 5,
    refY: 5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 8,
    markerHeight: 8,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 10 5 L 0 10 z",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 1,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-pointStart",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refX: 4.5,
    refY: 5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 8,
    markerHeight: 8,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 5 L 10 10 L 10 0 z",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 1,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-pointEnd-margin",
    className: "marker flowchart-v2",
    viewBox: "0 0 11.5 14",
    refX: 11.5,
    refY: 7,
    markerUnits: "userSpaceOnUse",
    markerWidth: 10.5,
    markerHeight: 14,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 11.5 7 L 0 14 z",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-pointStart-margin",
    className: "marker flowchart-v2",
    viewBox: "0 0 11.5 14",
    refX: 1,
    refY: 7,
    markerUnits: "userSpaceOnUse",
    markerWidth: 11.5,
    markerHeight: 14,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,7 11.5,14 11.5,0",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-circleEnd",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refX: 11,
    refY: 5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 11,
    markerHeight: 11,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 1,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-circleStart",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refX: -1,
    refY: 5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 11,
    markerHeight: 11,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 1,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-circleEnd-margin",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refY: 5,
    refX: 12.25,
    markerUnits: "userSpaceOnUse",
    markerWidth: 14,
    markerHeight: 14,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-circleStart-margin",
    className: "marker flowchart-v2",
    viewBox: "0 0 10 10",
    refX: -2,
    refY: 5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 14,
    markerHeight: 14,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 0,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-crossEnd",
    className: "marker cross flowchart-v2",
    viewBox: "0 0 11 11",
    refX: 12,
    refY: 5.2,
    markerUnits: "userSpaceOnUse",
    markerWidth: 11,
    markerHeight: 11,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1,1 l 9,9 M 10,1 l -9,9",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 2,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-crossStart",
    className: "marker cross flowchart-v2",
    viewBox: "0 0 11 11",
    refX: -1,
    refY: 5.2,
    markerUnits: "userSpaceOnUse",
    markerWidth: 11,
    markerHeight: 11,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1,1 l 9,9 M 10,1 l -9,9",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 2,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-crossEnd-margin",
    className: "marker cross flowchart-v2",
    viewBox: "0 0 15 15",
    refX: 17.7,
    refY: 7.5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 12,
    markerHeight: 12,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1,1 L 14,14 M 1,14 L 14,1",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 2.5
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "my-svg_flowchart-v2-crossStart-margin",
    className: "marker cross flowchart-v2",
    viewBox: "0 0 15 15",
    refX: -3.5,
    refY: 7.5,
    markerUnits: "userSpaceOnUse",
    markerWidth: 12,
    markerHeight: 12,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1,1 L 14,14 M 1,14 L 14,1",
    className: "arrowMarkerPath",
    style: {
      strokeWidth: 2.5,
      strokeDasharray: "1, 0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "root"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "clusters"
  })), /*#__PURE__*/React.createElement("g", {
    className: "edges edgePaths"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184,70.5999984741211L184,106.5999984741211",
    id: "my-svg-L_A_B_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 32 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_A_B_0",
    "data-points": "W3sieCI6MTg0LCJ5Ijo3MC41OTk5OTg0NzQxMjExfSx7IngiOjE4NCwieSI6MTEwLjU5OTk5ODQ3NDEyMTF9XQ==",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.5,253.09991979599L159.5,277.5999984741211L159.5,290.5289306622556Q159.5,297.5999984741211 152.42893218813452,297.5999984741211L95.07106781186548,297.5999984741211Q88,297.5999984741211 88,304.67106628598657L88,374.5999984741211",
    id: "my-svg-L_B_C_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 183.6717987060547 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_B_C_0",
    "data-points": "W3sieCI6MTU5LjUsInkiOjI1My4wOTk5MTk3OTU5OX0seyJ4IjoxNTkuNSwieSI6Mjc3LjU5OTk5ODQ3NDEyMTF9LHsieCI6MTU5LjUsInkiOjI5Ny41OTk5OTg0NzQxMjExfSx7IngiOjg4LCJ5IjoyOTcuNTk5OTk4NDc0MTIxMX0seyJ4Ijo4OCwieSI6Mzc4LjU5OTk5ODQ3NDEyMTF9XQ==",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.5,253.09991979599L208.5,277.5999984741211L208.5,290.5289306622556Q208.5,297.5999984741211 215.57106781186548,297.5999984741211L272.9289321881345,297.5999984741211Q280,297.5999984741211 280,304.67106628598657L280,374.5999984741211",
    id: "my-svg-L_B_D_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 183.6717987060547 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_B_D_0",
    "data-points": "W3sieCI6MjA4LjUsInkiOjI1My4wOTk5MTk3OTU5OX0seyJ4IjoyMDguNSwieSI6Mjc3LjU5OTk5ODQ3NDEyMTF9LHsieCI6MjA4LjUsInkiOjI5Ny41OTk5OTg0NzQxMjExfSx7IngiOjI4MCwieSI6Mjk3LjU5OTk5ODQ3NDEyMTF9LHsieCI6MjgwLCJ5IjozNzguNTk5OTk4NDc0MTIxMX1d",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,437.1999969482422L280,473.1999969482422",
    id: "my-svg-L_D_E_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 32 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_D_E_0",
    "data-points": "W3sieCI6MjgwLCJ5Ijo0MzcuMTk5OTk2OTQ4MjQyMn0seyJ4IjoyODAsInkiOjQ3Ny4xOTk5OTY5NDgyNDIyfV0=",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,535.7999954223633L280,571.7999954223633",
    id: "my-svg-L_E_F_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 32 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_E_F_0",
    "data-points": "W3sieCI6MjgwLCJ5Ijo1MzUuNzk5OTk1NDIyMzYzM30seyJ4IjoyODAsInkiOjU3NS43OTk5OTU0MjIzNjMzfV0=",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.56666564941406,732.9666614045127L252.56666564941406,760.4000015258789L252.56666564941406,773.3289337140134Q252.56666564941406,780.4000015258789 245.4955978375486,780.4000015258789L191.07106781186548,780.4000015258789Q184,780.4000015258789 184,787.4710693377444L184,857.4000015258789",
    id: "my-svg-L_F_G_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 183.67172241210938 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_F_G_0",
    "data-points": "W3sieCI6MjUyLjU2NjY2NTY0OTQxNDA2LCJ5Ijo3MzIuOTY2NjYxNDA0NTEyN30seyJ4IjoyNTIuNTY2NjY1NjQ5NDE0MDYsInkiOjc2MC40MDAwMDE1MjU4Nzg5fSx7IngiOjI1Mi41NjY2NjU2NDk0MTQwNiwieSI6NzgwLjQwMDAwMTUyNTg3ODl9LHsieCI6MTg0LCJ5Ijo3ODAuNDAwMDAxNTI1ODc4OX0seyJ4IjoxODQsInkiOjg2MS40MDAwMDE1MjU4Nzg5fV0=",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.43333435058594,732.9666614045127L307.43333435058594,760.4000015258789L307.43333435058594,773.3289337140134Q307.43333435058594,780.4000015258789 314.5044021624514,780.4000015258789L368.9289321881345,780.4000015258789Q376,780.4000015258789 376,787.4710693377444L376,857.4000015258789",
    id: "my-svg-L_F_H_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 183.67169189453125 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_F_H_0",
    "data-points": "W3sieCI6MzA3LjQzMzMzNDM1MDU4NTk0LCJ5Ijo3MzIuOTY2NjYxNDA0NTEyN30seyJ4IjozMDcuNDMzMzM0MzUwNTg1OTQsInkiOjc2MC40MDAwMDE1MjU4Nzg5fSx7IngiOjMwNy40MzMzMzQzNTA1ODU5NCwieSI6NzgwLjQwMDAwMTUyNTg3ODl9LHsieCI6Mzc2LCJ5Ijo3ODAuNDAwMDAxNTI1ODc4OX0seyJ4IjozNzYsInkiOjg2MS40MDAwMDE1MjU4Nzg5fV0=",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,937.5999984741211L376,973.5999984741211",
    id: "my-svg-L_H_I_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 32 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_H_I_0",
    "data-points": "W3sieCI6Mzc2LCJ5Ijo5MzcuNTk5OTk4NDc0MTIxMX0seyJ4IjozNzYsInkiOjk3Ny41OTk5OTg0NzQxMjExfV0=",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376,1053.7999954223633L376,1089.7999954223633",
    id: "my-svg-L_I_J_0",
    className: "edge-thickness-normal edge-pattern-solid edge-thickness-normal edge-pattern-solid flowchart-link",
    style: {
      strokeDasharray: "0 0 32 4",
      strokeDashoffset: 0
    },
    "data-edge": "true",
    "data-et": "edge",
    "data-id": "L_I_J_0",
    "data-points": "W3sieCI6Mzc2LCJ5IjoxMDUzLjc5OTk5NTQyMjM2MzN9LHsieCI6Mzc2LCJ5IjoxMDkzLjc5OTk5NTQyMjM2MzN9XQ==",
    "data-look": "neo",
    markerEnd: "url(#my-svg_flowchart-v2-pointEnd-margin)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabels"
  }, /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel",
    transform: "translate(87.83984375, 328.0999984741211)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "label",
    "data-id": "L_B_C_0",
    transform: "translate(0.00390625, -10.5)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {},
    x: -73.84375,
    y: 0,
    width: 147.6796875,
    height: 21
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    textAnchor: "middle",
    style: {}
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Warning"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " or"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " advisory"))))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel",
    transform: "translate(279.7890625, 328.0999984741211)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "label",
    "data-id": "L_B_D_0",
    transform: "translate(-0.046875, -10.5)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {},
    x: -32.2421875,
    y: 0,
    width: 64.578125,
    height: 21
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    textAnchor: "middle",
    style: {}
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Blocking"))))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel",
    transform: "translate(183.77734375, 810.9000015258789)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "label",
    "data-id": "L_F_G_0",
    transform: "translate(-0.05078125, -10.5)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {},
    x: -12.2265625,
    y: 0,
    width: 24.5546875,
    height: 21
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    textAnchor: "middle",
    style: {}
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "No"))))))), /*#__PURE__*/React.createElement("g", {
    className: "edgeLabel",
    transform: "translate(375.5546875, 810.9000015258789)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "label",
    "data-id": "L_F_H_0",
    transform: "translate(0.5, -10.5)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {},
    x: -16.0546875,
    y: 0,
    width: 31.109375,
    height: 21
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    textAnchor: "middle",
    style: {}
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Yes")))))))), /*#__PURE__*/React.createElement("g", {
    className: "nodes"
  }, /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-A-0",
    "data-look": "neo",
    transform: "translate(184, 41.29999923706055)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -29.299999237060547,
    width: 152,
    height: 58.599998474121094
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -17.299999237060547)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Read"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " conflict"))), _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "and"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " cause"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-B-1",
    "data-look": "neo",
    transform: "translate(184, 194.0999984741211)"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "83.5,0 167,-83.5 83.5,-167 0,-83.5",
    className: "label-container",
    transform: "translate(-83, 83.5)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -8.5)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Severity"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-C-3",
    "data-look": "neo",
    transform: "translate(88, 407.89999771118164)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -29.299999237060547,
    width: 152,
    height: 58.599998474121094
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -17.299999237060547)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Review"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " required"))), _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "action"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-D-5",
    "data-look": "neo",
    transform: "translate(280, 407.89999771118164)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -29.299999237060547,
    width: 152,
    height: 58.599998474121094
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -17.299999237060547)"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan0 || (_tspan0 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Correct"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " plan"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " or"))), _tspan1 || (_tspan1 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "source"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " input"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-E-7",
    "data-look": "neo",
    transform: "translate(280, 506.49999618530273)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -29.299999237060547,
    width: 152,
    height: 58.599998474121094
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -17.299999237060547)"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Recalculate"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " and"))), _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "inspect"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-F-9",
    "data-look": "neo",
    transform: "translate(280, 668.0999984741211)"
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "92.29999923706055,0 184.5999984741211,-92.29999923706055 92.29999923706055,-184.5999984741211 0,-92.29999923706055",
    className: "label-container",
    transform: "translate(-91.79999923706055, 92.29999923706055)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -17.299999237060547)"
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Blocker"))), _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "remains?"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-G-11",
    "data-look": "neo",
    transform: "translate(184, 890.7000007629395)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -29.299999237060547,
    width: 152,
    height: 58.599998474121094
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -17.299999237060547)"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Continue"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " normal"))), _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "review"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-H-13",
    "data-look": "neo",
    transform: "translate(376, 899.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -38.099998474121094,
    width: 152,
    height: 76.19999694824219
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -26.099998474121094)"
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Correct"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " further"))), _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "or"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " seek"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " reviewer"))), _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "2.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "decision"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-I-15",
    "data-look": "neo",
    transform: "translate(376, 1015.6999969482422)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -38.099998474121094,
    width: 152,
    height: 76.19999694824219
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -26.099998474121094)"
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Authorized"))), _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "override:"))), _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "2.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "required"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " reason"))))))), /*#__PURE__*/React.createElement("g", {
    className: "node default",
    id: "my-svg-flowchart-J-17",
    "data-look": "neo",
    transform: "translate(376, 1131.8999938964844)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "basic label-container",
    style: {},
    x: -76,
    y: -38.099998474121094,
    width: 152,
    height: 76.19999694824219
  }), /*#__PURE__*/React.createElement("g", {
    className: "label",
    style: {},
    transform: "translate(0, -26.099998474121094)"
  }, _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", null)), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "background",
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    y: -10.1,
    style: {}
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "-0.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "Approval"))), _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "records"), /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, " blocker"))), _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    className: "text-outer-tspan row",
    x: 0,
    y: "2.1em",
    dy: "1.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    fontStyle: "normal",
    className: "text-inner-tspan",
    fontWeight: "normal"
  }, "snapshot")))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "my-svg-drop-shadow",
    height: "130%",
    width: "130%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 4,
    dy: 4,
    stdDeviation: 0,
    floodOpacity: 0.06,
    floodColor: "#000000"
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "my-svg-drop-shadow-small",
    height: "150%",
    width: "150%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 2,
    stdDeviation: 0,
    floodOpacity: 0.06,
    floodColor: "#000000"
  })))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "my-svg-gradient",
    gradientUnits: "objectBoundingBox",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2e718e",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "hsl(200, 0%, 87.8431372549%)",
    stopOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockers);
export default __webpack_public_path__ + "static/media/blockers.775b93df50bc639f87fc174c738d521e.svg";
export { ForwardRef as ReactComponent };